import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { BlogGrid } from "~/components/blog-grid";

export const Route = createFileRoute("/blog/members/")({
  head: () => ({
    title: "Member Blog",
    meta: [
      {
        name: "description",
        content: "Exclusive articles for Dream Coach Match members.",
      },
    ],
  }),
  component: MemberBlogPage,
});

function MemberBlogPage() {
  return (
    <div className="mx-auto min-h-screen max-w-screen-md px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
      <h1 className="font-heading mb-8 text-3xl text-black sm:text-4xl">
        Dream Coach Match Member Blog
      </h1>
      <p className="text-text-secondary mb-8 text-lg">
        Articles curated especially for our members.
      </p>
      <BlogGrid
        query={{ "data.tags": { $elemMatch: { $eq: "for-members" } } }}
      />
    </div>
  );
}
